<template>
  <div>
    <router-view />
  </div>
</template>
<script>

import router from '@/router'
import { SET_APP_MACHINE_ID } from '@/store/mutation-types'
import { SET_ORGANIZATION_ID } from '@/store/action-types'

export default {
  name: 'HomeFS',
  data () {
    return {
    }
  },
  components: {
  },
  async mounted () {
    await this.initialize()
  },
  methods: {
    pingWatchdog: async function () {
      if (this.$store.state.device.configuration) {
        // Only ping if we have received our configuration
        await fetch('https://localhost:5001/tickle', {
          method: 'POST',
        })
      }
    },
    async initialize () {
      await this.$store.commit("device/" + SET_APP_MACHINE_ID, router.currentRoute.query)
      setInterval(this.pingWatchdog, 15000)
      const tasks = [
        this.$store.dispatch('configuration/fetchStaticConfiguration'),
        this.$store.dispatch('data/fetchOrganizations'),
        this.$store.dispatch("device/fetchDeviceConfiguration"),
      ]
      await Promise.allSettled(tasks)
      const orgByUrl = Object.fromEntries(this.$store.state.data.organizations.map(org => [org.url, org]))
      const parentUrls = new Set(this.$store.state.data.organizations.map(org => org.parent))
      const singleChild = Object.keys(orgByUrl).find(url => !parentUrls.has(url))
      await this.$store.dispatch('display/' + SET_ORGANIZATION_ID, orgByUrl[singleChild].id)
    }
  },
  watch: {
    $route: async function (to, from) {
      if (to.path === '/') {
        await this.initialize()
      }
    }
  }
}
</script>
